module.exports = __webpack_public_path__ + "img/广告图1.4328f60a.jpg";